module.exports = __webpack_public_path__ + "res/28-img_bottom.13df69f55187f18c08b32a911767c3dc.png";